import { Button } from "@/components/ui/button";
import assistantStore, { openAssistant } from "@/stores/assistantStore";
import { useStore } from "@tanstack/react-store";
import { useTranslation } from "react-i18next";

/**
 * Opens the assistant again, on every page, while it is closed: the panel comes back with its
 * conversation as it was (nothing is sent). An answer that arrived while it was closed shows as a
 * pink dot on the button, as in the list.
 */
const AssistantButton = () => {
    const { t } = useTranslation();
    const unreadAnswer = useStore(assistantStore, (s) => s.unreadAnswer);
    const label = t(
        unreadAnswer
            ? "vistassistant.openAssistantUnread"
            : "vistassistant.openAssistant",
    );

    return (
        <Button
            aria-label={label}
            className="relative h-11 rounded-full bg-assistant-lavender px-5 font-body text-sm font-semibold text-primary-darkest transition-colors hover:bg-white"
            onClick={() => openAssistant()}
            size="blank"
            title={label}
            variant="invisible"
        >
            {t("vistassistant.title")}
            {unreadAnswer && (
                <span
                    aria-hidden
                    className="absolute -right-0.5 -top-0.5 size-3 rounded-full border-2 border-primary-darkest bg-primary-pink"
                />
            )}
        </Button>
    );
};

export default AssistantButton;
